import {messageDuration} from "@/config";
import pinyin from 'pinyin'
import request from "@/dianwuyi/request";
import * as qiniu from "qiniu-js";

/**
 * 拼音首字母查询
 * @param {Array} data
 * @param {String} field
 * @param {String} keywords
 */
export function pinyinFilter(data, field, keywords) {
  return data.filter(item => {
    //如果直接包含输入值直接返回true
    let _value = item[field] ? item[field] : ""
    if (_value.toLowerCase().indexOf(keywords.toLowerCase()) !== -1) return true;

    //将label拆散成小写拼音数组
    let arr = pinyin(_value, {
      style: pinyin.STYLE_FIRST_LETTER
    });

    //拼接成完整label的拼音
    let spell = arr.join('');
    //lengths 是label完整拼音 中每个汉字第一个拼音字母的index值的数组
    let lengths = [0];
    for (let i = 0; i < arr.length - 1; i++) {
      lengths.push(lengths[i] + arr[i].length);
    }
    //判断label完整拼音 中 输入值的 index 是不是等于某个汉字第一个拼音字母的index值
    return lengths.indexOf(spell.indexOf(keywords.toLowerCase())) !== -1;
  })
}

/**
 * 分组统计
 * @param {Array} datas 数据集合
 * @param {Array} keys 分组键值["class","sex"]
 * @param {Function} callback(subTotal,item) 回调函数(例如求和还是计算总数) <br/> 求和每个班级总人数 var result = groupBy(datas,["class"],function (cul,data){return cul + 1; }); <br/>
 * 统计每个班级男生女生总分 var result = groupBy(datas,["class","sex"],function (cul,data){return cul + data["score"]; });
 * @returns {{}}
 */
export function groupBy(datas, keys, callback) {
  let groups = {};
  let len = keys.length;
  datas.forEach(function (data) {
    let tempObj = null;
    keys.forEach(function (key, index) {
      var val = data[key];
      if (tempObj == null) {
        tempObj = groups;
      }
      //最后一个元素赋值操作
      if (index == len - 1) {
        let cal = 0;
        if (tempObj.hasOwnProperty(val)) {
          cal = tempObj[val];
        }
        tempObj[val] = callback(cal, data);
      } else {
        if (tempObj.hasOwnProperty(val)) {
          tempObj = tempObj[val];
        } else {
          tempObj[val] = {};
          tempObj = tempObj[val];
        }
      }
    })

  });

  return groups;
}

/**
 * [orderBy description]
 * @param  {[type]} source [description]
 * @param  {[type]} fields [字段1,字段2]
 * @param  {[type]} type  {asc, desc}  [排序类型]
 * @return {[type]}        [description]
 */
export function orderBy(source, orders, type) {
  if (!orders instanceof Array || orders.length == 0) {
    console.error("第二个参数需要传入数组[字段1,字段2]")
    return
  }
  if (source instanceof Array && orders instanceof Array && orders.length > 0) {

    let ordersc = orders.concat([]);
    let sorttype = type || 'asc';
    let results = [];
    let totalSum = {};

    function grouporder(source, orders, totalSum) {

      source.sort(function (a, b) {
        let convertA = a[orders[0]];
        let convertB = b[orders[0]];
        if (typeof convertA == 'string' && typeof convertB == 'string') {
          if (sorttype.toUpperCase() == 'ASC') {
            return convertA.localeCompare(convertB);
          } else {
            return convertB.localeCompare(convertA);
          }
        } else {
          if (sorttype.toUpperCase() == 'ASC') {
            return convertA - convertB;
          } else {
            return convertB - convertA;
          }
        }

      })

      let groupmap = new Map();
      source.forEach((item) => {
        if (groupmap.has(item[orders[0]])) {
          groupmap.get(item[orders[0]]).push(item);
        } else {
          groupmap.set(item[orders[0]], []);
          groupmap.get(item[orders[0]]).push(item);
        }
      })


      orders.shift();

      for (let [key, val] of groupmap) {

        totalSum[key] = {};
        totalSum[key].name = key;
        totalSum[key].value = val.length;
        if (orders.length == 0) {
          results = results.concat(val);
        } else {
          totalSum[key].children = {};
          let orderscopy = orders.concat([]);
          grouporder(val, orderscopy, totalSum[key].children);
        }
      }
    }

    grouporder(source, ordersc, totalSum);

    return {
      results: results,
      totalSum: totalSum
    };
  } else {
    return source;
  }
}

/**
 * @method 向下递归查找
 * @param data
 * @param field
 * @param params
 * @returns {function(*, *=, *=): {node: null}}
 */
export function getFirstNode(data, field, params) {
  let node = null;

  function getNodebyParams(data, field, params) {
    //1.第一层 root 深度遍历整个data
    for (var i = 0; i < data.length; i++) {
      if (node) {
        break;
      }
      var obj = data[i];
      if (obj[field] === params) {
        //找到了与params匹配的节点，结束递归
        node = obj;
        break;
      } else {
        if (obj.children && obj.children.length) {
          //递归往下找
          getNodebyParams(obj.children, field, params);
        } else {
          //跳出当前递归，返回上层递归
          continue;
        }
      }
    }
  }

  getNodebyParams(data, field, params)
  return node;

}


/**
 *
 * @param data
 * @param fieldName 需要合并的字段名
 * @param spanMethodParams {row, column, rowIndex, columnIndex}
 * @returns {{colspan: (number), rowspan: number}|{colspan: number, rowspan: number}}
 */
export function tableSpanMethod(data, fieldName, {row, column, rowIndex, columnIndex}) {

  // let _firstValue = data[rowIndex][fieldName];
  let _firstValue = data[rowIndex][fieldName] instanceof Array ? JSON.stringify(data[rowIndex][fieldName]) : data[rowIndex][fieldName]

  if (rowIndex > 0 && data[(rowIndex - 1)][fieldName] == _firstValue) {
    return {
      rowspan: 0,
      colspan: 0
    }
  }
  let _rowSpan = 0;
  for (let i = rowIndex; i < data.length; i++) {
    let _rowValue = data[i][fieldName] instanceof Array ? JSON.stringify(data[i][fieldName]) : data[i][fieldName]
    if (_rowValue == _firstValue) {
      _rowSpan++
    } else {
      break
    }
    //
    // if (data[i][fieldName] == _firstValue) {
    //   _rowSpan++
    // } else {
    //   break
    // }
  }
  const _col = _rowSpan > 0 ? 1 : 0;
  return {
    rowspan: _rowSpan,
    colspan: _col
  }
}

/**
 * @method 计算表格合并行
 * @param data 表格数据源
 * @param fieldName 合并的字段
 * @returns {*[]} [1,2,0] 共三行,第二行和第三行合并
 */
export function calcRowSpanArr(data, fieldName) {
  let _rowSpanAttr = []
  for (let i = 0; i < data.length; i++) {
    if (i === 0) {
      _rowSpanAttr.push(1)
      this.pos = 0
    } else {
      if (data[i][fieldName] != null && data[i][fieldName].toString().length > 0 && data[i][fieldName] === data[i - 1][fieldName]) {
        _rowSpanAttr[this.pos] = _rowSpanAttr[this.pos] + 1;
        _rowSpanAttr.push(0)
      } else {
        _rowSpanAttr.push(1)
        this.pos = i;
      }
    }
  }
  return _rowSpanAttr

}

export function merge(/* obj1, obj2, obj3, ... */) {
  var result = {}

  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val)
    } else {
      result[key] = val
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue)
  }
  return result
}

export function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return
  }
  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /* eslint no-param-reassign:0 */
    obj = [obj]
  }

  if (Array.isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(obj, obj[i], i, obj)
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(obj, obj[key], key, obj)
      }
    }
  }
}

/**
 * methods 生成uuid
 * @returns {string}
 */
export function uuid() {
  let s = [];
  let hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4';
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = '-';

  let _uuidA = s.join('');
  return _uuidA;
}

export function thousandFormat(number) {
  // / <summary>
  // / 千分位格式化
  // / </summary>
  // / <param name="number"></param>
  // / <returns type=""></returns>
  if (!number) return "0";
  let num = number + "";

  num = num.replace(new RegExp(",", "g"), "");
  // 正负号处理
  let symble = "";
  if (/^([-+]).*$/.test(num)) {
    symble = num.replace(/^([-+]).*$/, "$1");
    num = num.replace(/^([-+])(.*)$/, "$2");
  }

  if (/^[0-9]+(\.[0-9]+)?$/.test(num)) {


    num = num.replace(new RegExp("^[0]+", "g"), "");
    if (/^\./.test(num)) {
      num = "0" + num;
    }

    let decimal = num.replace(/^[0-9]+(\.[0-9]+)?$/, "$1");
    let integer = num.replace(/^([0-9]+)(\.[0-9]+)?$/, "$1");

    let re = /(\d+)(\d{3})/;

    while (re.test(integer)) {
      integer = integer.replace(re, "$1,$2");
    }

    return symble + integer + decimal;
  } else {
    return number;
  }
}

export function toMoney(number, len) {
  // if (!number) return 0;

  if (len != undefined) {
    return thousandFormat(toDecimal(number, len));
  }
  return thousandFormat(toDecimal(parseFloat(number), 2));
}

export function toDecimal(x, len) {
  let f = parseFloat(x);
  if (isNaN(f)) {
    f = 0
  }
  f = Math.round(x * 100) / 100;
  let s = f.toString();
  let rs = s.indexOf(".");
  if (rs < 0) {
    rs = s.length;
    s += ".";
  }

  while (s.length <= rs + len) {
    s += "0";
  }
  if (len == 0) {
    s = s.slice(0, -1)
  }
  return s;
}

export function confirm(content, title, confirmButtonText, cancelButtonText) {

  // vant.Dialog.confirm({
  //   title: '标题',
  //   message: '弹窗内容',
  //
  // });

  return Vue.prototype.$confirm(content, title || '温馨提示', {
    confirmButtonText: confirmButtonText || "确定",
    cancelButtonText: cancelButtonText || "取消",
    closeOnClickModal: false,
    type: 'warning',
    lockScroll: false,
  })

}

export function error(content) {
  Vue.prototype.$baseMessage(content, "error")

  // Vue.prototype.$baseMessage(content, 'error', 'vab-hey-message-error');

  // return Vue.prototype.$msgbox({
  //   message: content,
  //   type: "error",
  //   duration: messageDuration,
  //   showClose: true,
  // })
}

/**
 * 保留小数位，返回Float
 * @param number
 * @param len
 * @returns {number}
 */
export function toFixed(number, len) {
  if (!len) {
    len = 2
  }
  if (!number) {
    number = 0
  }
  // return Math.floor(new BigNumber(number).toNumber() * 100) / 100
  return new BigNumber(new BigNumber(number).toFixed(2)).toNumber()

}

export function dataURItoBlob(base64Data) {
  let byteString
  if (base64Data.split(',')[0].indexOf('base64') >= 0)
    byteString = atob(base64Data.split(',')[1]) //base64 解码
  else {
    byteString = unescape(base64Data.split(',')[1])
  }
  let mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0] //mime类型 -- image/png
  let ia = new Uint8Array(byteString.length) //创建视图
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  let blob = new Blob([ia], {
    type: mimeString,
  })
  return blob
}

export async function capture(dom) {
  let _capture = await html2canvas(dom, {
    useCORS: true,
  })
  let _base64 = _capture
    .toDataURL('image/png', 1.0)
    .replace('image/png', 'image/octet-stream')
  let _data = await request({
    url: '/qiniu/getUploadToken',
    method: 'post',
    data: {},
  })
  let _uploadToken = _data.data
  let _fileName = uuid().replace(new RegExp('-', 'g'), '') + '.png'
  let _file = dataURItoBlob(_base64, _fileName)
  return new Promise((resolve, reject) => {
    let _observable = qiniu.upload(_file, _fileName, _uploadToken.token)
    let observer = {
      next(res) {
      },
      error(err) {
        error(err)
        reject(err)
      },
      async complete(res) {
        res.url = _uploadToken.url + '/' + res.key
        resolve(res.url)
      },
    }
    _observable.subscribe(observer)
  })
}

/**
 * 递归过滤节点，但保留原树结构，即符合条件节点的父路径上所有节点不管是否符合条件都保留
 * @param {Node[]} nodes 要过滤的树
 * @param {node => boolean} predicate 过滤条件，符合条件的节点保留(参数为函数，返回值为布尔值)
 * @param {node => boolean} wrapMatchFn 层级条件(参数为函数，返回值为布尔值)
 * @return 过滤后的包含根节点数组
 */
export function filterSearchTree(nodes, predicate, wrapMatchFn = () => false) {
  // 如果已经没有节点了，结束递归
  if (!(nodes && nodes.length)) {
    return []
  }
  const newChildren = []
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i]
    // 想要截止匹配的那一层（如果有匹配的则不用递归了，直接取下面所有的子节点）
    if (wrapMatchFn(node) && predicate(node)) {
      newChildren.push(node)
      continue
    }
    const subs = filterSearchTree(node.children, predicate, wrapMatchFn)

    // 以下两个条件任何一个成立，当前节点都应该加入到新子节点集中
    // 1. 子孙节点中存在符合条件的，即 subs 数组中有值
    // 2. 自己本身符合条件
    if ((subs && subs.length) || predicate(node)) {
      node.children = subs || []
      newChildren.push(node)
    }
  }
  return newChildren.length ? newChildren : []
}


export const chartColor = ['#3682be', '#45a776', '#f05326', '#334f65', '#ddae33', '#844bb3', '#df3881']


